module.exports = __webpack_public_path__ + "img/clock.54da630f.svg";